/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_dashboard_transactions_recent = /** @type {(inputs: {}) => string} */ () => {
	return `Transacciones Recientes`
};

const en_dashboard_transactions_recent = /** @type {(inputs: {}) => string} */ () => {
	return `Recent Transactions`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const dashboard_transactions_recent = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dashboard_transactions_recent(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("dashboard_transactions_recent", locale)
	if (locale === "es") return es_dashboard_transactions_recent(inputs)
	return en_dashboard_transactions_recent(inputs)
};
export { dashboard_transactions_recent as "dashboard.transactions.recent" }